import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SignUpRoutingModule} from './sign-up-routing.module'
import {RegisterComponent,ConfirmationDialog, TermsAndConditionDialog} from './register/register.component';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {CdkStepperModule} from '@angular/cdk/stepper';
import {MatDialogModule} from '@angular/material/dialog';
import {NgStepperModule} from 'angular-ng-stepper';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatFormFieldModule} from '@angular/material/form-field';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatInputModule } from '@angular/material/input';
import { AlertModule } from '../alert/alert.module';
import {MatCheckboxModule} from '@angular/material/checkbox';
@NgModule({
    declarations: [
        RegisterComponent,
        ConfirmationDialog,
    ],
    imports: [
        CommonModule,
        SignUpRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        CdkStepperModule,
        NgStepperModule,
        MatDialogModule,
        MatIconModule,
        MatTooltipModule,
        MatFormFieldModule,
        FlexLayoutModule,
        MatInputModule,
        AlertModule,
        MatCheckboxModule
    ]
})
export class SignUpModule { }
